import axiosInstance, { errorHandler } from "./api";

const login = axios => payload => {
  delete axios.defaults.headers.common.Authorization;

  return axios
    .post("/api/v2/authenticate", payload)
    .then(({ data }) => data)
    .then(({ data }) => {
      axios.defaults.headers.common.Authorization = `Bearer ${data.id_token}`;
      return data.id_token;
    })
    .catch(err => {
      if (err.data) {
        axios.defaults.headers.common.Authorization = `Bearer ${err.data.id_token}`;
      }

      errorHandler(err);
    });
};

const fetchUserData = axios => username => {
  return axios
    .get(`/api/user-infos/login/${username}`)
    .then(({ data }) => data)
    .catch(errorHandler);
};

const changePassword = axios => payload => {
  return axios
    .post("/api/account/change-password", payload)
    .then(({ data }) => data)
    .catch(errorHandler);
};

const logout = axios => () => {
  return axios
    .post("/api/logout")
    .then(({ data }) => data)
    .catch(error => {
      // Retry once if the first attempt fails
      return axios
        .post("/api/logout")
        .then(({ data }) => data)
        .catch(errorHandler);
    });
};

const resetPassword = axios => ({ login }) => {
  axios.defaults.headers.common.Authorization = "";

  return axios
    .post("/api/account/reset-password", {
      login,
    })
    .then(({ data }) => data)
    .catch(errorHandler);
};

export default {
  logout: logout(axiosInstance),
  login: login(axiosInstance),
  fetchUserData: fetchUserData(axiosInstance),
  changePassword: changePassword(axiosInstance),
  resetPassword: resetPassword(axiosInstance),
};
